import { InternalAxiosRequestConfig } from "axios";
import { useUserStore } from "@/stores/user";

export default function auth(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const userStore = useUserStore();

  if (userStore.token !== null) {
    config.headers.Authorization = `Bearer ${userStore.token.access_token}`;
  }

  return config;
}
